// GENERATED FILE - DO NOT MODIFY
export enum ServiceCallContractBillingMethod {
    Activity = "A",
    Category = "C",
    CustomerPricing = "T",
}

export let nameof = "ServiceCallContractBillingMethod";
